import { Box } from '@mui/material';
import LazySearchField from '../../../../../../../../../../components/FormInputs/TextField/LazySearchField';
import Typography from '../../../../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import { usePackStyles } from '../../../styles/usePackStyles';

interface PacksMenuHeaderMobileProps {
  readMode: boolean;
  onSearch: (query: string) => void;
}

const PacksMenuHeaderMobile = ({ readMode, onSearch }: PacksMenuHeaderMobileProps) => {
  const { classes: packStyles } = usePackStyles();
  const { translate } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box className={packStyles.headerSubTitleContainer}>
        <Typography variant="h8.5-regular">{translate(LangEnum.PACKS_MENU_HELP_TEXT)}</Typography>
        {!readMode && (
          <LazySearchField
            onChangeWithDebounce={onSearch}
            placeholder={translate(LangEnum.PACKS_MENU_SEARCH_PACKS_LABEL)}
          />
        )}
      </Box>
    </Box>
  );
};

export default PacksMenuHeaderMobile;
